import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input, model, output } from '@angular/core';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { FormDisplayComponent } from '@modules/forms/components/form-display/form-display.component';
import { SlideInDirective } from '@modules/shared/directives/slide-in.directive';
import { FormReport } from '@pixacare/forms';
import { formatUsername } from '@pixacare/shared';
import { NavListItem } from '@shared/components/nav-list/nav-list-item';
import { NavListComponent } from '@shared/components/nav-list/nav-list.component';
import { TuiButton, TuiScrollbar, TuiTitle } from '@taiga-ui/core';
import { TuiFade } from '@taiga-ui/kit';

@Component({
  selector: 'pxc-sadm-entity-protocols',
  templateUrl: './sadm-entity-protocols.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TuiButton,
    TuiScrollbar,
    TuiFade,
    FormDisplayComponent,
    TuiTitle,
    TranslocoDirective,
    NavListComponent,
    SlideInDirective,
  ],
  host: {
    class: 'flex min-h-0 flex-col gap-4',
  },
})
export class SadmEntityProtocolsComponent {
  readonly protocolReports = input.required<FormReport[]>();
  readonly heading = input<string>();
  readonly canEdit = input(false);
  // The history slides in when the panel appears; its close button stays in place.
  readonly slideDirection = input(0);
  readonly selectedIndex = model(0);

  readonly edit = output<void>();
  readonly closed = output<void>();

  private readonly translocoService = inject(TranslocoService);
  private readonly datePipe = inject(DatePipe);

  readonly selectedReport = computed(() => this.protocolReports()[this.selectedIndex()]);

  readonly navItems = computed(() =>
    this.protocolReports().map((report): NavListItem => ({
      title: this.translocoService.translate('{{ date }} à {{ time }}', {
        date: this.datePipe.transform(report.date, 'mediumDate'),
        time: this.datePipe.transform(report.date, 'shortTime'),
      }),
      subtitle: report.createdBy ? formatUsername(report.createdBy) : undefined,
    })),
  );
}
